// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  margin-bottom: 0;
  margin-top: 0.2222222222rem;
  font-size: 0.7777777778rem;
  color: var(--ion-color-danger);
  text-align: right;
  padding-right: 0.4444444444rem;
}

p {
  margin: 0;
}
p::first-letter {
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/components/validation-messages/validation-messages.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,8BAAA;EACA,iBAAA;EACA,8BAAA;AADF;;AAGA;EACE,SAAA;AAAF;AAEE;EACE,yBAAA;AAAJ","sourcesContent":["@use \"../../../theme/mixins.scss\" as *;\n\n:host {\n  display: block;\n  margin-bottom: 0;\n  margin-top: calculateRem(4px);\n  font-size: calculateRem(14px);\n  color: var(--ion-color-danger);\n  text-align: right;\n  padding-right: calculateRem(8px);\n}\np {\n  margin: 0;\n\n  &::first-letter {\n    text-transform: uppercase;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
